import _asyncToGenerator from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.regexp.replace.js";
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import 'quasar/dist/quasar.ie.polyfills.js';
import '@quasar/extras/roboto-font/roboto-font.css';
import '@quasar/extras/material-icons/material-icons.css';

// We load Quasar stylesheet file
import 'quasar/dist/quasar.sass';
import 'src/css/app.scss';
import 'src/css/header.scss';
import 'src/css/clock-style.scss';
import 'src/css/img-style.scss';
import 'src/css/config-style.scss';
import 'src/css/calendar-style.scss';
import 'src/css/panel-core-style.scss';
import 'src/css/video-style.scss';
import '@quasar/quasar-ui-qmediaplayer/src/index.sass';
import Vue from 'vue';
import createApp from "./app.js";
import qboot_Bootrouter from 'boot/router';
import qboot_Bootaxios from 'boot/axios';
import qboot_Quasarquasarappextensionqmediaplayersrcbootregisterjs from '@quasar/quasar-app-extension-qmediaplayer/src/boot/register.js';
function start() {
  return _start.apply(this, arguments);
}
function _start() {
  _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$createApp, app, store, router, routeUnchanged, redirect, urlPath, bootFiles, i;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return createApp();
        case 2:
          _yield$createApp = _context.sent;
          app = _yield$createApp.app;
          store = _yield$createApp.store;
          router = _yield$createApp.router;
          routeUnchanged = true;
          redirect = function redirect(url) {
            routeUnchanged = false;
            window.location.href = url;
          };
          urlPath = window.location.href.replace(window.location.origin, '');
          bootFiles = [qboot_Bootrouter, qboot_Bootaxios, qboot_Quasarquasarappextensionqmediaplayersrcbootregisterjs];
          i = 0;
        case 11:
          if (!(routeUnchanged === true && i < bootFiles.length)) {
            _context.next = 29;
            break;
          }
          if (!(typeof bootFiles[i] !== 'function')) {
            _context.next = 14;
            break;
          }
          return _context.abrupt("continue", 26);
        case 14:
          _context.prev = 14;
          _context.next = 17;
          return bootFiles[i]({
            app: app,
            router: router,
            store: store,
            Vue: Vue,
            ssrContext: null,
            redirect: redirect,
            urlPath: urlPath
          });
        case 17:
          _context.next = 26;
          break;
        case 19:
          _context.prev = 19;
          _context.t0 = _context["catch"](14);
          if (!(_context.t0 && _context.t0.url)) {
            _context.next = 24;
            break;
          }
          window.location.href = _context.t0.url;
          return _context.abrupt("return");
        case 24:
          console.error('[Quasar] boot error:', _context.t0);
          return _context.abrupt("return");
        case 26:
          i++;
          _context.next = 11;
          break;
        case 29:
          if (!(routeUnchanged === false)) {
            _context.next = 31;
            break;
          }
          return _context.abrupt("return");
        case 31:
          new Vue(app);
        case 32:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[14, 19]]);
  }));
  return _start.apply(this, arguments);
}
start();